import {CustomCardView} from "./custom-card.view";
export default CustomCardView;
